// extracted by mini-css-extract-plugin
module.exports = {"unreadMessageDot":"_34f8ynph6mwBhA1K5fze7X","readingMessageDot":"_3Be9-Al8J8-OQOhWsgVRJS","readMessageDot":"_1mLip3r4p7-EpF3MzpiQiM"};